module.exports = __webpack_public_path__ + "static/media/intro.e972f53a.mp3";